const TOC = () => {
    /**
     * Automatic Table of Contents Generator with Numbering
     */
    document.addEventListener('DOMContentLoaded', function() {
        const contentArea = document.querySelector('.single-post__entry-content, .knowledge-center-single__entry-content');
        const tocContainer = document.querySelector('.table-of-contents');

        // Early exit if required elements don't exist
        if (!contentArea || !tocContainer) return;

        const headings = contentArea.querySelectorAll('h2, h3, h4, h5, h6');

        // Hide TOC if no headings found
        if (headings.length === 0) {
            tocContainer.style.display = 'none';
            return;
        }

        const tocList = tocContainer.querySelector('.table-of-contents__list');
        const tocItems = [];
        const counters = { h2: 0, h3: 0, h4: 0, h5: 0, h6: 0 };

        // Constants
        const HEADER_OFFSET = 120;
        const LEVEL_MAP = {
            2: 'h2',
            3: 'h3',
            4: 'h4',
            5: 'h5',
            6: 'h6'
        };

        /**
         * Reset counters below a given level
         */
        function resetCounters(fromLevel) {
            const levels = Object.keys(counters);
            const startIndex = levels.indexOf(LEVEL_MAP[fromLevel]) + 1;

            for (let i = startIndex; i < levels.length; i++) {
                counters[levels[i]] = 0;
            }
        }

        /**
         * Generate number prefix for heading
         */
        function getNumberPrefix(level) {
            if (level === 2) return ''; // H2 has no numbering
            const levelKey = LEVEL_MAP[level];
            return counters[levelKey] > 0 ? `${counters[levelKey]}. ` : '';
        }

        /**
         * Update heading counters
         */
        function updateCounters(level) {
            const levelKey = LEVEL_MAP[level];
            counters[levelKey]++;
            resetCounters(level);
        }

        /**
         * Smooth scroll to element
         */
        function smoothScrollTo(element) {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - HEADER_OFFSET;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }

        /**
         * Create TOC item element
         */
        function createTOCItem(heading, index, numberPrefix) {
            const id = `toc-${index}`;
            heading.id = id;

            const level = parseInt(heading.tagName.charAt(1));
            const tocItem = document.createElement('li');
            tocItem.className = `table-of-contents__item table-of-contents__item--level-${level}`;

            const tocLink = document.createElement('a');
            tocLink.href = `#${id}`;
            tocLink.textContent = heading.textContent; // add number prefix if applicable here
            tocLink.dataset.target = id;

            // Click handler for smooth scroll
            tocLink.addEventListener('click', (e) => {
                e.preventDefault();
                smoothScrollTo(heading);

                // Update URL hash
                if (history.pushState) {
                    history.pushState(null, null, `#${id}`);
                }
            });

            tocItem.appendChild(tocLink);
            return { tocItem, id };
        }

        /**
         * Remove active class from all items
         */
        function clearActiveStates() {
            tocItems.forEach(({ element }) => {
                element.classList.remove('table-of-contents__item--active');
            });
        }

        /**
         * Set active state for TOC item
         */
        function setActiveState(targetId) {
            clearActiveStates();
            const activeItem = tocItems.find(item => item.id === targetId);
            if (activeItem) {
                activeItem.element.classList.add('table-of-contents__item--active');
            }
        }

        // ============================================================================
        // BUILD TABLE OF CONTENTS
        // ============================================================================

        headings.forEach((heading, index) => {
            const level = parseInt(heading.tagName.charAt(1));

            // Update counters
            updateCounters(level);

            // Get number prefix
            const numberPrefix = getNumberPrefix(level);

            // Create TOC item
            const { tocItem, id } = createTOCItem(heading, index, numberPrefix);

            // Append to list
            tocList.appendChild(tocItem);

            // Store reference
            tocItems.push({
                element: tocItem,
                heading: heading,
                id: id
            });
        });

        // ============================================================================
        // INTERSECTION OBSERVER FOR ACTIVE STATE
        // ============================================================================

        const observerOptions = {
            root: null,
            rootMargin: `-${HEADER_OFFSET}px 0px -60% 0px`,
            threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setActiveState(entry.target.id);
                }
            });
        }, observerOptions);

        // Observe all headings
        headings.forEach(heading => observer.observe(heading));

        // Set first item as active on load
        if (tocItems.length > 0) {
            tocItems[0].element.classList.add('table-of-contents__item--active');
        }

        // ============================================================================
        // CLEANUP ON PAGE UNLOAD
        // ============================================================================

        window.addEventListener('beforeunload', () => {
            observer.disconnect();
        });
    });
};

export default TOC;
